import React from "react";
import styled from "styled-components";
import SideBar from "./sideBar";
import { Outlet } from "react-router-dom";
import Tasks from "./tasks";
import Header from "components/header/index";

const Page = styled.div`
  min-height: 100dvh;
`;

const Body = styled.div`
  display: flex;
  align-items: stretch;
`;

const Main = styled.main`
  flex: 1 1 auto;
  min-width: 0;
  margin-bottom: 200px;
`;

const NAV_H = 56;

const NMain = () => {
  return (
    <Page>
      <Body>
        <SideBar navHeight={NAV_H} />
        <Main>
          <Header />
          <Outlet />
          <Tasks />
        </Main>
      </Body>
    </Page>
  );
};

export default NMain;
